import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const SocialMediaTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [editForm, setEditForm] = useState({ points: 0, isActive: false });
  const dispatch = useDispatch();
  
  const fetchSocialTasks = async () => {
    try {
      setLoading(true);
      const { data, error } = await apiCall("GET", "/social-tasks");
      if (data && data.success) {
        console.log("Social tasks data:", data);
        setTasks(data.data || []);
      } else {
        toast.error(error?.message || "Failed to fetch social tasks");
      }
    } catch (e) {
      console.log(e.message);
      toast.error("Failed to fetch social tasks");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialTasks();
  }, []);

  const handleEdit = (task) => {
    setEditingTask(task._id);
    setEditForm({
      points: task.points,
      isActive: task.isActive
    });
  };

  const handleCancelEdit = () => {
    setEditingTask(null);
    setEditForm({ points: 0, isActive: false });
  };

  const handleUpdateTask = async (taskId) => {
    try {
      setLoading(true);
      // Find the task to get its type
      const task = tasks.find(t => t._id === taskId);
      const body = {
        type: task?.type,
        points: editForm.points,
        isActive: editForm.isActive
      };
      console.log("Update task body:", body);
      const { data, error } = await apiCall("POST", "/update-social-tasks", body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Task updated successfully!");
        setEditingTask(null);
        fetchSocialTasks(); // Refresh the data after update
      }
    } catch (error) {
      console.log("error------", error);
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <p className="m-0">
            Home / <span>Social Media Tasks</span>
          </p>
        </div>
        
        <div id="directIncomeDiv">
          <Row id="directTableRow" className="">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                {loading ? (
                  <p>Loading...</p>
                ) : tasks.length > 0 ? (
                  <table>
                    <tr>
                      <th>S No.</th>
                      <th>Type</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Points</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                    <tbody>
                      {tasks.map((task, index) => (
                        <tr key={task._id}>
                          <td>{index + 1}</td>
                          <td>
                            <span style={{
                              display: 'inline-block',
                              padding: '4px 8px',
                              fontSize: '12px',
                              fontWeight: '600',
                              textTransform: 'uppercase',
                              borderRadius: '4px',
                              color: 'white',
                              backgroundColor: task.type === 'instagram' ? '#E4405F' :
                                            task.type === 'facebook' ? '#1877F2' :
                                            task.type === 'twitter' ? '#1DA1F2' :
                                            task.type === 'telegram' ? '#0088CC' :
                                            task.type === 'discord' ? '#5865F2' :
                                            task.type === 'youtube' ? '#FF0000' :
                                            task.type === 'linkedin' ? '#0077B5' :
                                            task.type === 'whatsapp' ? '#25D366' :
                                            task.type === 'snapchat' ? '#FFFC00' :
                                            task.type === 'tiktok' ? '#000000' :
                                            task.type === 'reddit' ? '#FF4500' :
                                            task.type === 'pinterest' ? '#E60023' :
                                            task.type === 'quora' ? '#B92B27' :
                                            task.type === 'medium' ? '#00AB6C' :
                                            task.type === 'github' ? '#333333' : '#666666'
                            }}>
                              {task.type.toUpperCase()}
                            </span>
                          </td>
                          <td>{task.title}</td>
                          <td>{task.description}</td>
                          <td>
                            {editingTask === task._id ? (
                              <input
                                type="number"
                                value={editForm.points}
                                onChange={(e) => setEditForm({...editForm, points: parseInt(e.target.value) || 0})}
                                style={{
                                  width: '80px',
                                  padding: '4px 8px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  textAlign: 'center'
                                }}
                              />
                            ) : (
                              task.points
                            )}
                          </td>
                           <td>
                             {editingTask === task._id ? (
                               <select
                                 value={editForm.isActive ? 'active' : 'inactive'}
                                 onChange={(e) => setEditForm({...editForm, isActive: e.target.value === 'active'})}
                                 style={{
                                   padding: '4px 8px',
                                   border: '1px solid #ddd',
                                   borderRadius: '4px',
                                   fontSize: '14px',
                                   backgroundColor: 'white',
                                   cursor: 'pointer'
                                 }}
                               >
                                 <option value="active">Active</option>
                                 <option value="inactive">Inactive</option>
                               </select>
                             ) : (
                               <span style={{
                                 display: 'inline-block',
                                 padding: '4px 8px',
                                 fontSize: '12px',
                                 fontWeight: '600',
                                 textTransform: 'uppercase',
                                 borderRadius: '4px',
                                 color: 'white',
                                 backgroundColor: task.isActive ? '#4CAF50' : '#f44336'
                               }}>
                                 {task.isActive ? 'Active' : 'Inactive'}
                               </span>
                             )}
                           </td>
                          <td>
                             {editingTask === task._id ? (
                               <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                 <Button 
                                   type="button" 
                                   variant="success" 
                                   onClick={() => handleUpdateTask(task._id)}
                                   disabled={loading}
                                 >
                                   {loading ? "Saving..." : "Save"}
                                 </Button>
                                 <Button 
                                   type="button" 
                                   variant="secondary" 
                                   onClick={handleCancelEdit}
                                   disabled={loading}
                                 >
                                   Cancel
                                 </Button>
                               </div>
                             ) : (
                               <Button 
                                 type="button" 
                                 variant="primary" 
                                 onClick={() => handleEdit(task)}
                                 disabled={loading}
                               >
                                 Edit
                               </Button>
                             )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                    <p>No social media tasks found.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default SocialMediaTasks;